import { Duration, Effect } from 'effect'

/**
 * Starts immediately and delays success until at least the given duration has elapsed.
 * The timer runs concurrently: slower effects take no extra time. Failures and
 * interruption propagate immediately, cancelling the timer.
 */
export const minDuration =
  (duration: Duration.Input) =>
  <A, E, R>(self: Effect.Effect<A, E, R>) =>
    Effect.all([self, Effect.sleep(duration)], { concurrency: 'unbounded' }).pipe(
      Effect.map(([value]) => value)
    )
